module.exports = __webpack_public_path__ + "static/media/d4.fca31a41.jpeg";